import { FC } from "react";

import { Stack } from "@mui/material";

import { FormSkeleton } from "@/forms-design-system/FormSkeleton";

export const ThemedFundraiserSkeleton: FC = () => {
  return (
    <Stack direction="row" gap={1.5} alignItems="center" padding={1}>
      <FormSkeleton variant="rectangular" width={24} height={24} sx={{ flexShrink: 0, borderRadius: 0.375 }} />
      <Stack flexGrow={1} minWidth={0}>
        <FormSkeleton variant="text" width="100%" height={20} />
        <FormSkeleton variant="text" width="40%" height={16} />
      </Stack>
    </Stack>
  );
};
